import { defineStore } from 'pinia';

export const useEtiquetaStore = defineStore('etiqueta', {
  persist: true,
  state: () => ({
    connection: null,
    printers: [],
    printer: null,
  }),
  actions: {
    async setConnection(connection: 'qz' | null) {
      this.connection = connection;
    },
    async setPrinters(printers: string[]) {
      this.printers = printers;
    },
    async setPrinter(printer: string | null) {
      this.printer = printer;
    },
  },
});
